import { unescape } from 'lodash-es';
import sanitizeHtml from 'sanitize-html';

// HTML タグからテキストを取得
// 例：「<a> Text </a>」→ 「Text」
export const extractText = (text: string): string => {
  if (!text) return '';
  return unescape(sanitizeHtml(text, { allowedTags: [] }));
};
